/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import env from 'env'

export const getSubscriptionPlans = () => ({
  type: 'SUBSCRIPTIONS/PLANS',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscription-plans`,
      headers: {},
      method: 'GET',
    },
  },
  meta: {
    noAuth: true,
  },
})
getSubscriptionPlans.toString = () => 'SUBSCRIPTIONS/PLANS'

export const getSubscriptionPlansForRenew = () => ({
  type: 'SUBSCRIPTIONS/PLANS_RENEW',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscription-plans/renew`,
      headers: {},
      method: 'GET',
    },
  },
  meta: {},
})
getSubscriptionPlansForRenew.toString = () => 'SUBSCRIPTIONS/PLANS_RENEW'

export const acceptTerms = data => ({
  type: 'SUBSCRIPTIONS/ACCEPT_TERMS',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscriptions/current/terms/accept`,
      headers: {},
      method: 'POST',
      data,
    },
  },
  meta: {
    noAuth: true,
  },
})
acceptTerms.toString = () => 'SUBSCRIPTIONS/ACCEPT_TERMS'

export const updateShippingInfo = ({
   firstName,
   lastName,
   countryId,
   stateId,
   city,
   postalCode,
   address1,
   phoneNumber,
}) => ({
  type: 'SUBSCRIPTIONS/UPDATE_SHIPPING_ADDRESS',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscriptions/current/shipping-address`,
      data: {
        ShippingAddress: {
          firstName,
          lastName,
          countryId,
          stateId,
          city,
          postalCode,
          address1,
          phoneNumber,
        },
      },
      headers: {},
      method: 'PUT',
    },
  },
  meta: {
    noAuth: true,
  },
})
updateShippingInfo.toString = () => 'SUBSCRIPTIONS/UPDATE_SHIPPING_ADDRESS'

export const changeSubscriptionPlan = (subscriptionPlanId, customerSignature) => ({
  type: 'SUBSCRIPTIONS/CHANGE_SUBSCRIPTION_PLAN',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscriptions/current`,
      data: { subscriptionPlanId, customerSignature },
      headers: {},
      method: 'PUT',
    },
  },
  meta: {
    noAuth: true,
  },
})
changeSubscriptionPlan.toString = () => 'SUBSCRIPTIONS/CHANGE_SUBSCRIPTION_PLAN'

export const renewSubscriptionPlan = (subscriptionPlanId, customerSignature, termsRead) => ({
  type: 'SUBSCRIPTIONS/RENEW_SUBSCRIPTION_PLAN',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscriptions/current/renew/terms/accept-and-renew`,
      data: { subscriptionPlanId, customerSignature, termsRead },
      headers: {},
      method: 'POST',
    },
  },
  meta: {},
})
renewSubscriptionPlan.toString = () => 'SUBSCRIPTIONS/RENEW_SUBSCRIPTION_PLAN'

export const enrollSubscriptionPlan = (subscriptionPlanId, customerSignature) => ({
  type: 'SUBSCRIPTIONS/ENROLL_SUBSCRIPTION_PLAN',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscriptions/current/enroll/terms/accept-and-renew`,
      data: { subscriptionPlanId, customerSignature },
      headers: {},
      method: 'POST',
    },
  },
  meta: {},
})
enrollSubscriptionPlan.toString = () => 'SUBSCRIPTIONS/ENROLLSUBSCRIPTION_PLAN'

export const renewAndChangeSubscriptionPlan = (subscriptionPlanId, customerSignature) => ({
  type: 'SUBSCRIPTIONS/RENEW_AND_CHANGE_SUBSCRIPTION_PLAN',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscriptions/current/renew/terms/accept-and-change-ending-plan`,
      data: { subscriptionPlanId, customerSignature },
      headers: {},
      method: 'POST',
    },
  },
  meta: {},
})
renewAndChangeSubscriptionPlan.toString = () => 'SUBSCRIPTIONS/RENEW_AND_CHANGE_SUBSCRIPTION_PLAN'

export const cancelSubscription = data => ({
  type: 'SUBSCRIPTIONS/CANCEL_SUBSCRIPTION',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscriptions/current/cancel`,
      headers: {},
      method: 'POST',
      data,
    },
  },
  meta: {},
})
cancelSubscription.toString = () => 'SUBSCRIPTIONS/CANCEL_SUBSCRIPTION'

export const getCurrentSubscriptionPlan = () => ({
  type: 'SUBSCRIPTIONS/CURRENT_PLAN',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscriptions/current/plan`,
      headers: {},
      method: 'GET',
    },
  },
  meta: {
    noAuth: true,
  },
})
getCurrentSubscriptionPlan.toString = () => 'SUBSCRIPTIONS/CURRENT_PLAN'

export const getReceipt = (invoiceId) => ({
  type: 'SUBSCRIPTIONS/GET_RECEIPT',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscriptions/current/invoices/${invoiceId}/receipt`,
      headers: {
        'Content-Type': 'application/pdf'
      },
      responseType: 'blob',
      method: 'POST',
    },
  },
  meta: {
    getBlob: true,
  },
})
getReceipt.toString = () => 'SUBSCRIPTIONS/GET_RECEIPT'

export const getSubscriptionTerms = () => ({
  type: 'SUBSCRIPTIONS/GET_TERMS',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/subscriptions/current/terms',
      headers: {},
      method: 'GET',
    },
  },
  meta: {},
})
getSubscriptionTerms.toString = () => 'SUBSCRIPTIONS/GET_TERMS'

export const getTempSubscriptionTerms = () => ({
  type: 'SUBSCRIPTIONS/GET_TEMP_TERMS',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/subscriptions/current/terms/draft',
      headers: {},
      method: 'GET',
    },
  },
  meta: {},
})
getTempSubscriptionTerms.toString = () => 'SUBSCRIPTIONS/GET_TEMP_TERMS'

export const getSubscriptionRenewedTerms = () => ({
  type: 'SUBSCRIPTIONS/GET_TERMS_RENEWED',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/subscriptions/current/terms-renewed',
      headers: {},
      method: 'GET',
    },
  },
  meta: {},
})
getSubscriptionRenewedTerms.toString = () => 'SUBSCRIPTIONS/GET_TERMS_RENEWED'

export const getChangeSubscriptionTerms = (planId) => ({
  type: 'SUBSCRIPTIONS/GET_CHANGE_PLAN_TERMS',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscription-plans/${planId}/terms/draft`,
      headers: {},
      method: 'GET',
    },
  },
  meta: {},
})
getChangeSubscriptionTerms.toString = () => 'SUBSCRIPTIONS/GET_CHANGE_PLAN_TERMS'

export const getRenewSubscriptionTerms = (planId) => ({
  type: 'SUBSCRIPTIONS/GET_RENEW_PLAN_TERMS',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscription-plans/${planId}/renew/terms/draft`,
      headers: {},
      method: 'GET',
    },
  },
  meta: {},
})
getRenewSubscriptionTerms.toString = () => 'SUBSCRIPTIONS/GET_RENEW_PLAN_TERMS'

export const getEnrollSubscriptionTerms = (planId) => ({
  type: 'SUBSCRIPTIONS/GET_ENROLL_PLAN_TERMS',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscription-plans/${planId}/enroll/terms/draft`,
      headers: {},
      method: 'GET',
    },
  },
  meta: {},
})
getEnrollSubscriptionTerms.toString = () => 'SUBSCRIPTIONS/GET_ENROLL_PLAN_TERMS'

export const getRenewAndChangeSubscriptionTerms = (planId) => ({
  type: 'SUBSCRIPTIONS/GET_RENEW_AND_CHANGE_PLAN_TERMS',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/subscription-plans/${planId}/renew-and-change/terms/draft`,
      headers: {},
      method: 'GET',
    },
  },
  meta: {},
})
getRenewAndChangeSubscriptionTerms.toString = () => 'SUBSCRIPTIONS/GET_RENEW_AND_CHANGE_PLAN_TERMS'

export const getCancellationReasonList = () => ({
  type: 'SUBSCRIPTIONS/GET_CANCELLATIONREASON_LIST',
  payload: {
    apiAction: {
      hostname: env.api,
      url: 'api/subscriptions/cancellation-reasons',
      headers: {},
      method: 'GET',
    },
  },
  meta: {},
})
getCancellationReasonList.toString = () => 'SUBSCRIPTIONS/GET_CANCELLATIONREASON_LIST'
